module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAALBAMAAADPZMPnAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAASUExURUxpcdvb29vb29vb29vb29vb29lZ2GQAAAAFdFJOUwBERuutt+fN2wAAACpJREFUGNNjYMAKnBhwAWUFXDJMRuRpCsUBgnHpYTTEJSMsQD0tDI4MDADOTQpnX5L6RgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newjt.png
// module id = NEcs
// module chunks = 9 10